<template>
  <div class="navbar-wrapper" :class="{ 'is-scrolled': isScrolled }">
    <div class="blur-backdrop"></div>
    <nav class="navbar" :class="{ 'is-scrolled': isScrolled }">
      <div class="navbar-glow"></div>
      <div class="container">
        <div class="navbar-logo" :class="{ 'is-scrolled': isScrolled }">
          <router-link to="/" class="logo-link">
            <div class="logo-container">
              <div class="logo-icon">
                <span class="logo-shine"></span>
              </div>
              <span class="logo-text" :class="{ 'is-scrolled': isScrolled }">弦动魔方科技</span>
            </div>
          </router-link>
        </div>
        
        <div class="navbar-menu" :class="{ 'is-active': isMenuActive, 'is-scrolled': isScrolled }">
          <router-link to="/" class="navbar-item" :class="{ 'is-scrolled': isScrolled }" active-class="is-active">
            <span class="nav-text">首页</span>
            <span class="nav-indicator"></span>
          </router-link>
          <router-link to="/about" class="navbar-item" :class="{ 'is-scrolled': isScrolled }" active-class="is-active">
            <span class="nav-text">关于我们</span>
            <span class="nav-indicator"></span>
          </router-link>
          <router-link to="/solutions" class="navbar-item" :class="{ 'is-scrolled': isScrolled }" active-class="is-active">
            <span class="nav-text">AI解决方案</span>
            <span class="nav-indicator"></span>
          </router-link>
          <router-link to="/products" class="navbar-item" :class="{ 'is-scrolled': isScrolled }" active-class="is-active">
            <span class="nav-text">产品展示</span>
            <span class="nav-indicator"></span>
          </router-link>
          <router-link to="/partners" class="navbar-item" :class="{ 'is-scrolled': isScrolled }" active-class="is-active">
            <span class="nav-text">合作伙伴</span>
            <span class="nav-indicator"></span>
          </router-link>
        </div>
        
        <div class="navbar-end" :class="{ 'is-scrolled': isScrolled }">
          <button class="button is-primary">
            <span class="button-text">联系我们</span>
            <span class="button-icon"><i class="fas fa-arrow-right"></i></span>
            <div class="button-background"></div>
          </button>
        </div>
        
        <div class="navbar-burger" :class="{ 'is-scrolled': isScrolled, 'is-active': isMenuActive }" @click="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      isScrolled: false,
      isMenuActive: false,
      scrollY: 0
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    
    // 添加鼠标移动效果
    const navbar = document.querySelector('.navbar');
    if (navbar) {
      navbar.addEventListener('mousemove', this.handleMouseMove);
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    
    const navbar = document.querySelector('.navbar');
    if (navbar) {
      navbar.removeEventListener('mousemove', this.handleMouseMove);
    }
  },
  methods: {
    handleScroll() {
      // 使用 requestAnimationFrame 优化滚动性能
      requestAnimationFrame(() => {
        this.scrollY = window.scrollY;
        this.isScrolled = this.scrollY > 50;
      });
    },
    toggleMenu() {
      this.isMenuActive = !this.isMenuActive;
    },
    handleMouseMove(e) {
      if (this.isScrolled) return; // 只在非滚动状态下应用效果
      
      const glow = document.querySelector('.navbar-glow');
      if (!glow) return;
      
      const rect = e.currentTarget.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      glow.style.background = `radial-gradient(circle at ${x}px ${y}px, rgba(157, 110, 253, 0.15) 0%, rgba(157, 110, 253, 0) 70%)`;
    }
  }
}
</script>

<style scoped>
.navbar-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding: 0;
  transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex;
  justify-content: center;
}

.navbar-wrapper.is-scrolled {
  padding: 0.8rem;
}

.blur-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  z-index: -1;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.is-scrolled .blur-backdrop {
  opacity: 0.15;
}

.navbar {
  background: linear-gradient(135deg, rgba(42, 35, 68, 0.65) 0%, rgba(30, 25, 50, 0.85) 100%);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border-radius: 0;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1), 
              inset 0 1px 1px rgba(255, 255, 255, 0.1);
  transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  padding: 0.8rem 1.5rem;
  width: 100%;
  max-width: 100%;
  position: relative;
  overflow: hidden;
}

.navbar-glow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 0.8;
  transition: all 0.3s ease;
}

.navbar.is-scrolled {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.1) 100%);
  border-radius: 16px;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0.5rem 1rem;
  transform: translateY(0.5rem) scale(0.98);
  width: 80%;
  max-width: 1100px;
}

.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 0.5rem;
  transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
  z-index: 1;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
}

.navbar-logo {
  display: flex;
  align-items: center;
  transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

.navbar-logo.is-scrolled {
  transform: scale(0.9);
}

.logo-container {
  display: flex;
  align-items: center;
  position: relative;
}

.logo-icon {
  width: 20px;
  height: 20px;
  background: linear-gradient(135deg, #9D6EFD 0%, #C45FF5 100%);
  border-radius: 4px;
  margin-right: 10px;
  transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(157, 110, 253, 0.3);
}

.logo-shine {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: -100%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.5) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: logoShineSweep 3s infinite;
}

.logo-text {
  font-size: 1.25rem;
  font-weight: 700;
  color: white;
  transition: all 0.4s ease;
  background: linear-gradient(90deg, #ffffff 0%, #f0f0ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: 0.5px;
}

.logo-text.is-scrolled {
  background: linear-gradient(90deg, #ffffff 0%, #e2e2ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 700;
  text-shadow: 0 2px 3px rgba(0, 0, 0, 0.3);
}

.navbar-menu {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin: 0 auto;
  transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

.navbar-menu.is-scrolled {
  gap: 1.2rem;
}

.navbar-item {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  transition: all 0.3s cubic-bezier(0.25, 1, 0.5, 1);
  padding: 0.65rem 0.85rem;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.navbar-item.is-scrolled {
  color: #ffffff;
  font-weight: 600;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
}

.nav-text {
  position: relative;
  z-index: 2;
}

.nav-indicator {
  position: absolute;
  bottom: 3px;
  left: 50%;
  transform: translateX(-50%) scaleX(0);
  width: 10px;
  height: 2.5px;
  background: linear-gradient(90deg, #9D6EFD 0%, #C45FF5 100%);
  border-radius: 10px;
  transition: all 0.3s ease;
  transform-origin: center;
  opacity: 0;
}

.navbar-item:hover .nav-indicator,
.navbar-item.is-active .nav-indicator {
  opacity: 1;
  transform: translateX(-50%) scaleX(1);
  width: 20px;
}

.navbar-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  transform: scale(0.8);
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 1;
}

.navbar-item.is-scrolled::before {
  background-color: rgba(157, 110, 253, 0.05);
}

.navbar-item.is-scrolled {
  font-size: 0.95rem;
  padding: 0.55rem 0.75rem;
}

.navbar-item:hover, .navbar-item.is-active {
  color: white;
  transform: translateY(-2px);
}

.navbar-item.is-scrolled:hover, .navbar-item.is-scrolled.is-active {
  color: #ffffff;
  background: rgba(157, 110, 253, 0.2);
  box-shadow: 0 2px 12px rgba(157, 110, 253, 0.15);
}

.navbar-item:hover::before, .navbar-item.is-active::before {
  transform: scale(1);
  opacity: 1;
}

.navbar-item:active {
  transform: scale(0.95);
}

.navbar-item.is-scrolled .nav-indicator {
  background: linear-gradient(90deg, #d4b9ff 0%, #ffffff 100%);
  height: 3px;
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
}

.navbar-end {
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

.navbar-end.is-scrolled {
  transform: scale(0.95);
}

.button.is-primary {
  background: rgba(157, 110, 253, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 0.6rem 1.1rem;
  border-radius: 12px;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.25, 1, 0.5, 1);
  font-size: 0.95rem;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.button-text {
  position: relative;
  z-index: 2;
}

.button-icon {
  position: relative;
  z-index: 2;
  font-size: 0.85em;
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateX(-5px);
  width: 0;
}

.button.is-primary:hover .button-icon {
  opacity: 1;
  transform: translateX(4px);
  width: auto;
  margin-left: 6px;
}

.button-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(157, 110, 253, 0.4) 0%, rgba(196, 95, 245, 0.4) 100%);
  z-index: 0;
  transition: all 0.3s ease;
  opacity: 0;
  border-radius: 12px;
}

.button.is-primary:hover .button-background {
  opacity: 1;
  transform: scale(1);
  box-shadow: 0 4px 15px rgba(157, 110, 253, 0.2);
}

.navbar.is-scrolled .button.is-primary {
  background: rgba(157, 110, 253, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.navbar.is-scrolled .button.is-primary:hover {
  background: rgba(157, 110, 253, 0.25);
  transform: translateY(-2px);
}

.button.is-primary:active {
  transform: scale(0.96);
}

.navbar-burger {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 24px;
  height: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  z-index: 10;
}

.navbar-burger span {
  display: block;
  width: 100%;
  height: 2px;
  background-color: white;
  transition: all 0.3s ease;
  border-radius: 2px;
}

.navbar-burger.is-scrolled span {
  background-color: #ffffff;
  height: 2px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.navbar-burger.is-active span:nth-child(1) {
  transform: translateY(9px) rotate(45deg);
}

.navbar-burger.is-active span:nth-child(2) {
  opacity: 0;
}

.navbar-burger.is-active span:nth-child(3) {
  transform: translateY(-9px) rotate(-45deg);
}

@keyframes logoShineSweep {
  0% {
    left: -100%;
  }
  20%, 100% {
    left: 100%;
  }
}

@media screen and (max-width: 1023px) {
  .navbar-wrapper {
    padding: 0.75rem 1rem;
  }
  
  .navbar.is-scrolled {
    width: 90%;
  }
  
  .navbar-menu {
    display: none;
    position: absolute;
    top: calc(100% + 1rem);
    left: 1rem;
    right: 1rem;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    padding: 1.5rem;
    border-radius: 16px;
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1),
                0 5px 15px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.5);
    flex-direction: column;
    align-items: flex-start;
    z-index: 100;
    gap: 0.5rem;
  }
  
  .navbar-menu.is-active {
    display: flex;
    animation: fadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-15px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .navbar-item {
    padding: 0.9rem 1.2rem;
    width: 100%;
    border-radius: 12px;
    align-items: flex-start;
    color: #1a1a2e;
  }
  
  .nav-indicator {
    left: 12px;
    bottom: 35%;
    transform: none;
    width: 3px !important;
    height: 30%;
  }
  
  .navbar-item:hover .nav-indicator,
  .navbar-item.is-active .nav-indicator {
    transform: none;
    opacity: 1;
  }
  
  .navbar-burger {
    display: flex;
  }
}

@media screen and (max-width: 768px) {
  .navbar-wrapper {
    padding: 0.5rem;
  }
  
  .navbar-wrapper.is-scrolled {
    padding: 0.5rem;
  }
  
  .navbar {
    padding: 0.6rem 1rem;
  }
  
  .navbar.is-scrolled {
    padding: 0.5rem 0.8rem;
    width: 95%;
  }
  
  .logo-text {
    font-size: 1.15rem;
  }
}
</style> 